module.exports = __webpack_public_path__ + "static/media/bluecovid.d603a800.png";